<div
  class="search-crud-header"
  [class]="{ 'header-open': isOpenFilter }"
  *ngIf="showHeader"
>
  <!--<h3>{{titleWindow|translate}}</h3>-->
  <mo-search
    (onClickSearch)="_onClickSearch($event)"
    (onClickExport)="onExport()"
    (onClickExport1)="onExport1()"
    (onClickExport2)="onExport2()"
    (onClickImport)="onImport($event)"
    (onClickAdd)="onAdd()"
    (onClickOpenCloseFilter)="onOpenCloseFilter($event)"
    [showAdd]="showAdd"
    [showExport]="showExport"
    [showExport1]="showExport1"
    [showExport2]="showExport2"
    [showExport1Text]="showExport1Text"
    [showExport2Text]="showExport2Text"
    [showImport]="showImport"
    [showText]="showText"
    [minCharactersToSearch]="minCharactersToSearch"
    [addText]="addText"
    [filterText]="filterText"
    [isOpen]="isOpen"
    [moAddButtonTemplate]="MoAddButtonTemplate"
    [searchText]="searchText"
  >
    <ng-content></ng-content>
  </mo-search>
</div>
<div *ngIf="page !== undefined && page !== null" class="search-crud-body">
  <ng-template
    *ngTemplateOutlet="
      contentTemplate ?? contentTemplateDefault;
      context: { item: this }
    "
  ></ng-template>
</div>
<ng-template #contentTemplateDefault let-item="item">
  <gq-grid
    *ngIf="item.page.data !== null && item.columnDefs !== undefined"
    [data]="item.page.data"
    [rowIdField]="item.rowIdField"
    [columnDefs]="item.columnDefs"
    [autoSizeColumnsToFit]="item.autoSizeColumnsToFit"
    [showLoadingOverlay]="item.showLoadingOverlay"
    [rowClassRules]="item.rowClassRules"
    (onReady)="item._onReady($event)"
    (onSortChanged)="item._onSortChanged($event)"
    (onRowClicked)="item._onRowClicked($event)"
    (onRowDoubleClicked)="item._onRowDoubleClicked($event)"
  ></gq-grid>

  <div class="paging-row" *ngIf="item.showPaging">
    <!-- <mat-paginator
      *ngIf="item.showPaging"
      [length]="item.page.recordCount"
      [pageSize]="item.page.pageSize"
      [hidePageSize]="false"
      [pageIndex]="item.page.pageIndex - 1"
      [pageSizeOptions]="[25, 50, 75, 100]"
      (page)="item.onPage($event)"
    >
    </mat-paginator> -->
    <div class="pager-controls">
      <div class="pager-numbers">
        <button
          type="button"
          mat-button
          class="page-btn1"
          aria-label="Previous page"
          (click)="item.goTo(item.pageIndex0 - 1)"
          [disabled]="item.pageIndex0 === 0"
        >
          <svg
            viewBox="0 0 24 24"
            focusable="false"
            aria-hidden="true"
            class="mat-mdc-paginator-icon"
          >
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
          </svg>
        </button>

        <ng-container *ngIf="item.showStartEdge">
          <button
            mat-button
            class="page-btn"
            (click)="item.goTo(0)"
            [disabled]="item.pageIndex0 === 0"
          >
            1
          </button>
          <span class="dots" *ngIf="item.showStartDots">…</span>
        </ng-container>

        <ng-container *ngFor="let p of item.visiblePages0">
          <button
            mat-button
            class="page-btn"
            X
            (click)="item.goTo(p)"
            [disabled]="p === item.pageIndex0"
          >
            {{ p + 1 }}
          </button>
        </ng-container>

        <ng-container *ngIf="item.showEndEdge">
          <span class="dots" *ngIf="item.showEndDots">…</span>
          <button
            mat-button
            class="page-btn"
            (click)="item.goTo(item.pageCount - 1)"
            [disabled]="item.pageIndex0 === item.pageCount - 1"
          >
            {{ item.pageCount }}
          </button>
        </ng-container>

        <button
          type="button"
          mat-button
          class="page-btn1"
          aria-label="Next page"
          (click)="item.goTo(item.pageIndex0 + 1)"
          [disabled]="item.pageIndex0 === item.pageCount - 1"
        >
          <svg
            viewBox="0 0 24 24"
            focusable="false"
            aria-hidden="true"
            class="mat-mdc-paginator-icon"
          >
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
          </svg>
        </button>
      </div>
      <div>
        <!-- Combo pageSizeOptions -->
        <select
          [value]="item.page.pageSize"
          (change)="
            item.onPage({
              pageIndex: item.pageIndex0,
              pageSize: +$any($event.target).value,
            })
          "
          aria-label="Items per page"
        >
          <option *ngFor="let size of [25, 50, 75, 100]" [value]="size">
            {{ size }}
          </option>
        </select>
        <span class="page-label">/ Página</span>

        <!-- Combo selección de página -->
        <span class="page-label label-padding">Ir a: </span>
        <select
          [value]="item.pageIndex0"
          (change)="item.goTo(+$any($event.target).value)"
          aria-label="Go to page"
        >
          <option
            *ngFor="let p of [].constructor(item.pageCount); let i = index"
            [value]="i"
          >
            {{ i + 1 }}
          </option>
        </select>
      </div>

      <!-- Botones de paginación -->
    </div>
  </div>
</ng-template>
